export default __webpack_public_path__ + "static/media/shipment-no-images.674c6c0c.jpg";